function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61,118.17V110c.31-2,.57-4,.93-6a55,55,0,0,1,44-44.1c2-.36,4.08-.63,6.11-.94h8.15a4.41,4.41,0,0,0,.77.21A53.56,53.56,0,0,1,154.81,75c11.16,11.16,16.55,24.76,16.26,40.57a53.05,53.05,0,0,1-5.9,23.45,55,55,0,0,1-59,29.27c-22.2-3.85-40.36-21.89-44.26-44C61.59,122.25,61.31,120.21,61,118.17ZM116.09,75C94.74,75,77.21,92.41,77,113.41A39.09,39.09,0,1,0,116.09,75Z",
  transform: "translate(-61 -59)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M116.1,174.23h46.7a7.91,7.91,0,0,1,.79,15.79c-.36,0-.72,0-1.08,0H69.57c-4.7,0-8.26-3.33-8.33-7.75a7.87,7.87,0,0,1,7.91-8c8.54,0,17.08,0,25.63,0Z",
  transform: "translate(-61 -59)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M175.74,85.63a12.7,12.7,0,1,1,12.7-12.56A12.65,12.65,0,0,1,175.74,85.63Z",
  transform: "translate(-61 -59)"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    "data-name": "logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.44 131.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GHS Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.95a7fb08.svg";
export { ForwardRef as ReactComponent };